<template>
  <v-card tile flat>
    <v-toolbar fixed>
      <v-app-bar-nav-icon name="close">
        <v-icon medium @click="$emit('open',false)" color="primary">close</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title>
        <span class="title font-weight-bold">{{ $language.settings['Profile Configuration'] }}</span>
      </v-toolbar-title>
    </v-toolbar>
    <v-container fill-height v-if="!userProfile" mt-16>
      <v-row justify="center" align="center">
        <v-col cols="12" justify="center" align="center">
          <v-progress-circular indeterminate :size="70" :width="7" color="primary"></v-progress-circular>
          <h4 class=" mt-3">{{ $language.settings['Loading user details'] }}</h4>
        </v-col>
      </v-row>
    </v-container>

    <v-container fill-height v-else>
      <v-row no-gutters>
        <v-col cols="12">
          <v-list-item>
            <v-list-item-avatar size="120">
              <v-img :src="((userProfile || {}).public || {}).photoURL" @click="photoDialog = true">
                <v-container fill-height>
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-icon large color="grey ">add_a_photo</v-icon>
                    </v-col>
                  </v-row>
                </v-container>

              </v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="title pl-1">
                {{ ((userProfile || {}).public || {}).name }}
              </v-list-item-title>
              <v-list-item-subtitle class="subtitle py-1">
                <v-row no-gutters align="baseline">
                  <v-rating v-model="((userProfile || {}).public || {}).rating" small dense half-increments empty-icon="$vuetify.icons.ratingEmpty" color="primary" background-color="primary" readonly></v-rating>
                  <span class="px-2">({{ ((userProfile || {}).public || {}).rating }})</span>
                </v-row>
              </v-list-item-subtitle>
              <v-list-item-subtitle class="body-1 pl-1 py-1">
                {{ ((userProfile || {}).public || {}).reviewCount ? ((userProfile || {}).public || {}).reviewCount + `${ $language.settings['reviews'] }.` : `${ $language.settings['No reviews'] }.` }}
              </v-list-item-subtitle>
              <v-list-item-subtitle class="body-1 pl-1 py-1">
                {{ ((userProfile || {}).public || {}).completedJobs ? ((userProfile || {}).public || {}).completedJobs + `${ $language.settings['completed jobs'] }.` : `${ $language.settings['No completed jobs'] }.` }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
            </v-list-item-action>
          </v-list-item>
        </v-col>
        <v-col cols="12" class="my-4">
          <v-divider></v-divider>
        </v-col>
        <v-col cols="12" md="6">
          <div class="title  mb-3 text-xs-left">{{ $language.settings['Profile details'] }}
            <v-icon color="info" clas="ml-2" style="vertical-align: baseline; font-size: 14px" @click="openDetailsDialog">fas fa-edit</v-icon>
          </div>
          <div class="mb-1">
            <v-icon small color="grey lighten-1" class="mr-2" style="vertical-align: baseline;">fas fa-user</v-icon>
            <span :class="` ${ $vuetify.breakpoint.xs ? 'caption' : 'body-1'}`">{{ ((userProfile || {}).public || {}).name || 'No name' }}</span>
          </div>
          <div class="mb-1">
            <v-icon small color="grey lighten-1" class="mr-2" style="vertical-align: baseline;">fas fa-at</v-icon>
            <span :class="` ${ $vuetify.breakpoint.xs ? 'caption' : 'body-1'}`">{{ ((userProfile || {}).public || {}).email || 'No email' }}</span>
          </div>
          <div class="mb-1">
            <v-icon small color="grey lighten-1" style="vertical-align: baseline; margin-left: 3px; margin-right: 7px">fas fa-mobile-alt</v-icon>
            <span :class="` ${ $vuetify.breakpoint.xs ? 'caption' : 'body-1' } ml-1`">{{ ((userProfile || {}).public || {}).mobilePhone || 'No mobile phone'}}</span>
          </div>
          <div class="mb-1">
            <v-icon small color="grey lighten-1" style="vertical-align: baseline; margin-left: 3px; margin-right: 7px">fas fa-map-marker</v-icon>
            <span :class="` ${ $vuetify.breakpoint.xs ? 'caption' : 'body-1' } ml-1`">{{ (userProfile.address || {}).formatted_address || 'No address' }}</span>
          </div>
          <div class="mb-1">
            <v-icon small color="grey lighten-1" style="vertical-align: baseline; margin-left: 3px; margin-right: 7px">fas fa-share-alt-square</v-icon>
            <span :class="` ${ $vuetify.breakpoint.xs ? 'caption' : 'body-1' } ml-1`">{{ userProfile.referralId || 'No invite code' }}</span>
          </div>
        </v-col>
        <v-col cols="12" class="my-4" v-if="$vuetify.breakpoint.smAndDown">
          <v-divider></v-divider>
        </v-col>
        <v-col cols="12" md="6">
          <div class="title  mb-3">{{ $language.settings['Skills'] }}
            <v-icon color="info" clas="ml-2" style="vertical-align: baseline; font-size: 14px" @click="openSkillsDialog = true">fas fa-edit</v-icon>
          </div>
          <template class="" v-for="(skill, index) in ((userProfile || {}).public || {}).categories">
            <v-chip class=" ma-1" v-if="index<8" :key="skill+index"> {{ $language.settings.Categories[skill] }} </v-chip>
            <span v-if="index === 8" :key="skill+index">(+{{ ((userProfile || {}).public || {}).categories.length - 8 }} {{ $language.jobSearch['others'] }})</span>
          </template>
        </v-col>
        <v-col cols="12" class="my-4">
          <v-divider></v-divider>
        </v-col>
        <v-col cols="12" md="6">
          <div class="title  mb-3">{{ $language.settings['Payment Methods'] }}
          </div>
          <v-layout column justify-center align-center v-if="(userProfile.stripeCustomerAccount||{}).processing">
            <v-progress-circular indeterminate :size="70" :width="7" color="primary"></v-progress-circular>
          </v-layout>

          <v-list v-else>
            <v-list-item v-for="item in sources" :key="item.id">
              <v-list-item-avatar>
                <v-icon large :color="`${item.id === (userProfile.stripeCustomerAccount||{}).default_source?'primary':''}`">credit_card</v-icon>
              </v-list-item-avatar>

              <v-list-item-content :class="`${item.id === (userProfile.stripeCustomerAccount||{}).default_source?'primary--text':''}`">
                <v-list-item-title>
                  {{item.brand}} {{ $language.settings['ending'] }} ···· {{item.last4}} <span v-if="item.id === (userProfile.stripeCustomerAccount||{}).default_source" :class="`orange--text  text--darken-4 ${ $vuetify.breakpoint.xs ? 'caption' : 'body-1'}`">(default)</span>
                </v-list-item-title>

              </v-list-item-content>

              <v-list-item-action>
                <template>
                  <div class="text-xs-center">
                    <v-menu>
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">more_vert</v-icon>
                      </template>
                      <v-list>
                        <v-list-item @click="setNewDefault(item)" v-if="item.id !== (userProfile.stripeCustomerAccount||{}).default_source">
                          <v-list-item-title>Set as Default</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="deleteSource(item)">
                          <v-list-item-title>Delete</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </template>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <v-btn text small color="primary" @click="openPaymentDialog=true" v-if="hasSources">{{ $language.settings['add payment method'] }}</v-btn>
          <v-btn text color="red " @click="openPaymentDialog=true" v-else>
            <v-icon class="pr-4" v-if="!(userProfile.stripeCustomerAccount||{}).default_source">warning</v-icon><span class="bold">{{ $language.settings['add payment method'] }}</span>
          </v-btn>

          <v-dialog v-model="openPaymentDialog" :overlay="true" max-width="320" transition="dialog-transition">
            <AddStripe :is-cust="hasSources" @open="openPaymentDialog = false"></AddStripe>
          </v-dialog>
        </v-col>
        <v-col cols="12" class="my-4" v-if="$vuetify.breakpoint.smAndDown">
          <v-divider></v-divider>
        </v-col>
          <div class="title  ">{{ $language.settings['Reviews'] }}</div>

        <v-col cols="12" md="6" align="center">
          <div class="text-xs-center mt-1" v-if="Object.entries(((userProfile || {}).public || {}).ratings || []).length > 1">
            <v-icon color="info" class="mx-3" style="vertical-align: middle;" @click="prev">fas fa-arrow-circle-left</v-icon>
            <span class="">{{ currentReview + 1 }} / {{ Object.entries(((userProfile || {}).public || {}).ratings || []).length }}</span>
            <v-icon color="info" class="mx-3" style="vertical-align: middle;" @click="next">fas fa-arrow-circle-right</v-icon>
          </div>
          <v-window v-model="currentReview" :touch="{ left: prev, right: next }" v-if="((userProfile || {}).public || {}).ratings">
            <v-window-item v-for="(review) in (((userProfile || {}).public || {}).ratings || {})" :key="review.key">
              <div class="body-1  pa-3 text-xs-center">
                <v-rating size="16" v-model="review.rating" class="mb-1" color="yellow darken-3" background-color="grey darken-1" empty-icon="$vuetify.icons.ratingEmpty" half-increments readonly></v-rating>
                <div>
                  {{ review.comment }}
                </div>
                <div class="caption text-xs-right mt-2">
                  - From {{ review.ratedByName }} ({{ review.ratingDate|formatShortDate }})
                </div>
              </div>
            </v-window-item>
          </v-window>

          <div v-if="!((userProfile || {}).public || {}).ratings" class="text-xs-center py-3 ">
            {{ $language.settings['No reviews yet'] }}.
          </div>
        </v-col>
        <v-col cols="12" class="my-4">
          <v-divider></v-divider>
        </v-col>
        <v-col cols="12">
          <div class="title  mb-1">{{ $language.settings['Notifications'] }}</div>
          <v-list>
            <v-list-item>
              <v-list-item-avatar>
                <v-switch v-model="userProfile.pushToken" @click.native="enablePush" :ripple="false"></v-switch>
              </v-list-item-avatar>
              <v-list-item-title class="">{{ $language.settings['Enable Push Notifications'] }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
      <v-snackbar v-model="snackbar.show" :color="snackbar.status" :timeout="1500">
        {{ snackbar.message }}
      </v-snackbar>
      <v-dialog v-model="openSkillsDialog" persistent max-width="500px">
        <v-card>
          <v-card-title primary-title>
            {{ $language.settings['Skills'] }}
          </v-card-title>
          <v-layout row wrap class="pl-5">
            <template v-for="(category,index) in categories">
              <v-flex xs6 :key="category+index*2">
                <v-checkbox class="ma-0 mb-1 pa-1" hide-details :key="category._key" v-model="selectedCategories" :value="category._key">
                  <template v-slot:label>
                    <v-row no-gutters align="center">
                      <v-col cols="2">
                        <v-img :src="require(`@/assets/${category._key}.svg`)" height="24px" cover></v-img>
                      </v-col>
                      <v-col cols="9">
                        <span class="pl-2">
                          {{$language.settings.Categories[category._key]}}</span>
                      </v-col>
                    </v-row>
                  </template>
                </v-checkbox>
              </v-flex>
            </template>
          </v-layout>
          <v-card-actions>
            <v-row no-gutters align="center" justify="space-around" class="px-2">
              <v-col cols="5">
                <v-btn color="primary" block text @click.native="openSkillsDialog = false" :disabled="buttonLoading">{{ $language.settings['cancel'] }}</v-btn>
              </v-col>
              <v-col cols="5">
                <v-btn color="primary" block depressed @click="setCategory" :disabled="buttonLoading" :loading="buttonLoading">{{ $language.settings['Update'] }}</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>

      </v-dialog>
      <v-dialog v-model="editDetailsDialog" persistent max-width="600">
        <v-card class="pa-2">
          <v-row no-gutters>
            <v-col cols="12" md="6">
              <v-list-item dense>
                <v-list-item-content>
                  <v-text-field outlined dense v-model="((userProfile || {}).public || {}).firstName" :label="$language.registration['First Name']" required hide-details>
                    <template v-slot:prepend-inner>
                      <v-icon color="primary" class="pr-2">person</v-icon>
                    </template>
                  </v-text-field>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" md="6">
              <v-list-item dense>
                <v-list-item-content>
                  <v-text-field outlined dense v-model="((userProfile || {}).public || {}).lastName" :label="$language.registration['Last Name']" required hide-details>
                    <template v-slot:prepend-inner>
                      <v-icon color="primary" class="pr-2">person</v-icon>
                    </template>
                  </v-text-field>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12">
              <v-list-item dense>
                <v-list-item-content>
                  <v-text-field outlined dense v-model="((userProfile || {}).public || {}).email" :rules="emailRules" :label="$language.registration['E-mail']" required hide-details>
                    <template v-slot:prepend-inner>
                      <v-icon color="primary" class="pr-2">email</v-icon>
                    </template>
                  </v-text-field>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12">
              <v-list-item dense>
                <v-list-item-content>
                  <v-text-field outlined dense v-model="((userProfile || {}).public || {}).companyName" :label="$language.registration['Company Name (optional)']" hide-details>
                    <template v-slot:prepend-inner>
                      <v-icon color="primary" class="pr-2">business</v-icon>
                    </template>
                  </v-text-field>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12">
              <v-list-item dense>
                <v-list-item-content>
                  <v-text-field outlined dense v-model="((userProfile || {}).public || {}).mobilePhone" type="number" mask="phone" :rules="phoneRules" :label="$language.registration['Mobile Phone']" required hide-details>
                    <template v-slot:prepend-inner>
                      <v-icon color="primary" class="pr-2">phone</v-icon>
                    </template>
                  </v-text-field>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12">
              <v-list-item dense>
                <v-list-item-content>
                  <div :class="`v-text-field--outlined custom-input v-input v-input--is-label-active v-input--is-dirty v-input--dense ${$vuetify.theme.dark?'theme--dark':'theme--light'} v-text-field v-text-field--is-booted v-text-field--enclosed `">
                    <div class="v-input__control" style="height:40px">
                      <div :class="`v-input__slot `">
                        <div class="v-input__prepend-inner">
                          <v-icon>map</v-icon>
                        </div>
                        <gmap-autocomplete ref="search" :class="`v-text-field__slot pt-4 pl-2`" :label="$language.addJob['Job Address']" :placeholder="$language.addJob['Enter Job Address']" @place_changed="getAddressData">
                        </gmap-autocomplete>
                        <v-btn text icon class="mx-0 pr-0 mt-0 pt-1" @click="clear">
                          <v-icon medium class="pr-0">clear</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click.native="editDetailsDialog = false" :disabled="buttonLoading">{{ $language.settings['cancel'] }}</v-btn>
            <v-btn color="primary" depressed @click="updateProfile" :disabled="buttonLoading" :loading="buttonLoading">{{ $language.settings['Update'] }}</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent max-width="330">
        <v-card>
          <v-card-text>
            <div slot="header" class="title text-xs-center mb-4">{{ $language.settings['Edit Profile Photo'] }}</div>
            <div class="canvas-container" :style="`
              width: ${ $vuetify.breakpoint.xs ? 200 : $vuetify.breakpoint.sm ? 250 : 300 }px;
              height: ${ $vuetify.breakpoint.xs ? 200 : $vuetify.breakpoint.sm ? 250 : 300 }px;
              margin-left: calc(50% - ${ $vuetify.breakpoint.xs ? 100 : $vuetify.breakpoint.sm ? 125 : 150 }px);
            `">
              <croppa ref="myCroppa" :key="myKey" :width="$vuetify.breakpoint.smAndDown ? 250  : 300" :height="$vuetify.breakpoint.smAndDown ? 250 : 300" :placeholder="$language.registration['Add a photo']" :placeholder-font-size="22" :disabled="false" :prevent-white-space="true" :show-remove-button="false" :accept="'image/*'" @new-image-drawn="detectFiles" @file-choose="initial = false">
                <img style="width: calc(100vw - 44px); max-width: 331px; height: 200px;" :src="((userProfile || {}).public || {}).photoURL || ''" crossOrigin="anonymous" slot="initial" alt="User photo">
              </croppa>
            </div>
            <div>
              <v-layout row wrap justify-center>
                <v-spacer></v-spacer>
                <v-flex text-xs-center v-if="uploadReady">
                  <v-btn icon color="error" depressed @click="removeImage()" :disabled="uploading">
                    <v-icon color="white">
                      close
                    </v-icon>
                  </v-btn>
                  <br>
                  <small>{{ $language.settings['Remove Image'] }}</small>
                </v-flex>
                <v-flex text-xs-center v-if="!initial && (uploadReady && !uploadEnd)">
                  <v-btn icon color="success" depressed @click="upload">
                    <v-icon small v-if="!uploading" color="white">
                      fas fa-check
                    </v-icon>
                    <small class="white--text font-weight-bold" v-if="uploading">{{progressUpload}}%</small>
                  </v-btn>
                  <br>
                  <small>{{ $language.settings['Confirm upload'] }}</small>
                </v-flex>
                <v-spacer></v-spacer>
              </v-layout>
              <transition name="fade" appear mode="out-in">
                <v-alert :style="`width: ${ $vuetify.breakpoint.xs ? 80 : $vuetify.breakpoint.sm ? 50 : 45 }%`" key="end" v-if="uploadEnd" :value="true" class="text-xs-center my-2" color="success" icon="check_circle" outline>
                  {{ $language.registration["Image uploaded successfully"] }}
                </v-alert>
              </transition>
            </div>
          </v-card-text>

          <v-card-actions class="my-3">
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click.native="photoDialog = false" :disabled="uploading">{{ $language.settings["done"] }}</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="photoDialog" persistent :max-width="$vuetify.breakpoint.smAndDown ? 270 : 330">
        <v-card>
          <v-row>
            <v-col cols="12" justify="center" align="center">
              <croppa :key="myKey" ref="myCroppa" :width="$vuetify.breakpoint.smAndDown ? 250  : 300" :height="$vuetify.breakpoint.smAndDown ? 250 : 300" :placeholder="$language.registration['Add a photo']" :placeholder-font-size="22" :disabled="false" :prevent-white-space="true" :show-remove-button="true" :accept="'image/*'" @new-image-drawn="detectFiles" @file-choose="initial = false">
                <img style="width: calc(100vw - 44px); max-width: 331px; height: 200px;" :src="((userProfile || {}).public || {}).photoURL || ''" crossOrigin="anonymous" slot="initial" alt="User photo">

              </croppa>
            </v-col>
            <v-col cols="12" align="center">
              <v-btn fab small class="ma-1" color="primary" @click="rotatePhoto(-1)">
                <v-icon large>rotate_left</v-icon>
              </v-btn>
              <v-btn fab small class="ma-1" color="primary" @click="rotatePhoto(1)">
                <v-icon large>rotate_right</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-row no-gutters justify="space-around" class="px-2">
              <v-col cols="5">
                <v-btn color="primary" large block text @click.native="photoDialog = false">Cancel</v-btn>
              </v-col>
              <v-col cols="5">
                <v-btn @click="upload" color="primary" block large>Upload</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-container>
  </v-card>
</template>

<script>
import {
  mapState
} from 'vuex'
import AddStripe from '@/components/common/AddStripe'
const fb = require('@/services/firebaseConfig.js')

export default {
  components: {
    AddStripe
  },
  data () {
    return {
      currentReview: 0,
      details: {
        name: '',
        email: '',
        mobilePhone: '',
        address: '',
        referralId: ''
      },
      snackbar: {
        show: false,
        message: '',
        status: 'success'
      },
      buttonLoading: false,
      openSkillsDialog: false,
      editDetailsDialog: false,
      openPaymentDialog: false,
      text: 'Settings Updated',
      progressUpload: 0,
      fileName: '',
      uploadTask: '',
      uploading: false,
      uploadEnd: false,
      photoDialog: false,
      detailsDialog: false,
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      phoneRules: [
        (v) => !!v || 'Phone number is required',
        (v) => v.length === 10 || 'Must be a valid US phone number.'
      ],
      componentKey: 0,
      dataURL: '',
      uploadReady: false,
      initial: true,
      selectedCategories: [],
      img: null,
      myKey: 0,
      index: 0
    }
  },

  computed: {
    ...mapState(['currentUser', 'userProfile', 'userJobs', 'categories', 'filteredCategories', 'status']),
    isHefe () {
      return this.userProfile.userType.hefe ? 1 : 0
    },
    sources () {
      return (((this.userProfile || {}).stripeCustomerAccount || {}).sources || {}).data || {}
    },
    hasSources () {
      return (((this.userProfile || {}).stripeCustomerAccount || {}).sources || {}).data !== undefined && this.isHefe
    }
  },
  methods: {
    next () {
      this.currentReview += 1
    },

    prev () {
      this.currentReview -= 1
    },
    clear () {
      this.userProfile.location = []
      this.userProfile.address = {}
      this.$refs.search.$el.value = null
    },
    openDetailsDialog () {
      this.editDetailsDialog = true
      this.$nextTick(() => {
        this.$refs.search.value = this.userProfile.address.formatted_address
        this.index += this.index
      })
    },

    async updateProfile () {
      this.buttonLoading = true
      var updates = {}
      updates[`/user/${this.currentUser.uid}/profile/public/firstName`] = this.userProfile.public.firstName
      updates[`/user/${this.currentUser.uid}/profile/public/lastName`] = this.userProfile.public.lastName
      updates[`/user/${this.currentUser.uid}/profile/public/name`] = this.userProfile.public.firstName + ' ' + this.userProfile.public.lastName
      updates[`/user/${this.currentUser.uid}/profile/public/email`] = this.userProfile.public.email
      updates[`/user/${this.currentUser.uid}/profile/public/mobilePhone`] = this.userProfile.public.mobilePhone
      updates[`/user/${this.currentUser.uid}/profile/public/address`] = this.userProfile.public.address || ''
      updates[`/user/${this.currentUser.uid}/profile/public/location`] = this.userProfile.public.location || ''
      await fb.database.ref().update(updates)
      this.buttonLoading = false
      this.snackbar.show = true
      this.snackbar.message = this.$language.settings['Details updated successfully']
      this.editDetailsDialog = false
    },

    async setCategory () {
      if (this.selectedCategories.length > 0) {
        this.buttonLoading = true
        await fb.database.ref(`user/${this.currentUser.uid}/profile/public/categories`).set(this.selectedCategories)
        this.snackbar.show = true
        this.snackbar.message = this.$language.settings['Skills updated successfully']
        this.snackbar.status = 'success'
        this.buttonLoading = false
        this.openSkillsDialog = false
      } else {
        this.snackbar.show = true
        this.snackbar.message = this.$language.settings['You should have at least one skill selected']
        this.snackbar.status = 'error'
      }
    },

    switchModes () {
      var updates = {}
      if (this.userProfile.userType.hefe === true) {
        updates[`/user/${this.currentUser.uid}/profile/userType/hefe`] = true
        updates[`/user/${this.currentUser.uid}/profile/userType/obr`] = false
        fb.database.ref().update(updates)
      } else {
        updates[`/user/${this.currentUser.uid}/profile/userType/obr`] = true
        updates[`/user/${this.currentUser.uid}/profile/userType/hefe`] = false
        fb.database.ref().update(updates)
      }
    },
    //
    // IMAGE UPLOAD
    //
    rotatePhoto (dir) {
      this.$refs.myCroppa.rotate(dir)
    },
    detectFiles () {
      this.uploadReady = true
    },
    upload () {
      this.$refs.myCroppa.generateBlob(
        (blob) => {
          this.fileName = blob.name
          this.uploading = true
          this.uploadTask = fb.storage.ref(`images/${this.currentUser.uid}/profile_photo`).put(blob)
        },
        'image/jpeg'
      )
    },

    async removeImage () {
      this.myKey += 1
      this.$refs.myCroppa.remove()
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/public/photoURL`] = ''
      await fb.database.ref().update(updates)
      this.uploadEnd = false
      this.uploading = false
      this.uploadReady = false
      this.initial = true
    },
    //
    // END IMAGE UPLOAD
    //

    getAddressData: function (addressData) {
      var components = {}

      addressData.address_components.map(k => {
        components[k.types[0]] = k.short_name
      })
      this.userProfile.address = {}
      this.userProfile.address.url = addressData.url
      this.userProfile.address.address1 = `${components.street_number || ''} ${components.route || ''}`
      this.userProfile.address.city = components.locality || ''
      this.userProfile.address.state = components.administrative_area_level_1 || ''
      this.userProfile.address.zip = components.postal_code || ''
      this.userProfile.address.html = addressData.adr_address || ''
      this.userProfile.address.formatted_address = addressData.formatted_address || ''
      this.userProfile.location = [(addressData.geometry.location.lat() || 0), (addressData.geometry.location.lng() || 0)]
      // fb.database.ref(`user/${this.currentUser.uid}/profile`).set(this.userProfile)
    },
    setNewDefault (item) {
      item.date = new Date()
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/stripeCustomerAccount/setNewDefault`] = item
      updates[`user/${this.currentUser.uid}/profile/stripeCustomerAccount/processing`] = true
      fb.database.ref().update(updates)
    },
    deleteSource (item) {
      item.date = new Date()
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/stripeCustomerAccount/deleteSource`] = item
      updates[`user/${this.currentUser.uid}/profile/stripeCustomerAccount/processing`] = true
      fb.database.ref().update(updates)
    },

    enablePush () {
      if (this.userProfile.pushToken) {
        fb.messaging.requestPermission()
          .then(() => fb.messaging.getToken())
          .then((token) => {
            this.userProfile.pushToken = token
            var updates = {}
            updates[`user/${this.currentUser.uid}/profile/pushToken`] = this.userProfile.pushToken
            fb.database.ref().update(updates)
          })
          .catch(function (err) {
            console.log('Unable to get permission to notify.', err)
            var updates = {}
            updates[`user/${this.currentUser.uid}/profile/pushToken`] = false
            fb.database.ref().update(updates)
          })
      } else {
        var updates = {}
        updates[`user/${this.currentUser.uid}/profile/pushToken`] = false
        fb.database.ref().update(updates)
      }
    }
  },
  watch: {
    'userProfile.public.categories': {
      handler: function () {
        this.selectedCategories = [...this.userProfile.public.categories || []] || []
      },
      immediate: true
    },
    uploadTask: function () {
      this.uploadTask.on('state_changed', sp => {
        this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
      },
      null,
      () => {
        this.uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
          this.uploadEnd = true
          this.downloadURL = downloadURL
          this.userProfile.public.photoURL = downloadURL
          var updates = {}
          updates[`user/${this.currentUser.uid}/profile/public/photoURL`] = this.userProfile.public.photoURL
          Object.keys(this.userJobs).map(k => {
            if (this.userJobs[k].createdBy === this.currentUser.uid) {
              updates[`jobs/${this.userJobs[k]._key}/hefeAvatar`] = this.userProfile.public.photoURL
            } else {
              updates[`jobs/${this.userJobs[k]._key}/applicants/${this.currentUser.uid}/avatar`] = this.userProfile.public.photoURL
            }
          })
          fb.database.ref().update(updates)
          this.photoDialog = false
          this.initial = true
          this.uploading = false
          this.uploadReady = false
        })
      })
    }
  },
  filters: {

  }
}
</script>

<style>
.canvas-container {
  background: #fff;
  border: 2px solid #aaa;
  border-radius: 50%;
  margin: 14px 14px;
  overflow: hidden;
}
</style>
<style scoped>
/*.croppa-container {
  width: calc(100vw - 40px);
  max-width: 840px !important;
  height: 200px;
  margin: 0 auto;
  display: block;
}*/

.no-padding-hint > .v-input__control > .v-text-field__details {
  padding: 0px !important;
  margin: 0px !important;
}

.scrollable {
  overflow-y: auto;
}

.custom-input {
  border: 0.5px solid;
  border-color: grey;
}
.active {
  border: 0.5px solid;
  border-color: #ff5722;
}
.centered-input input {
  text-align: end;
}
</style>
